<template>
  <div class="nav">
    <div class="main">
      <!-- pc -->
      <img
        class="pc-logo"
        src="@/assets/images/pc/logo.png"
        alt=""
      />
      <img
        src="@/assets/images/pc/download.png"
        @click="downloadApp()"
        alt=""
        class="download"
      />
    </div>
  </div>
</template>

<script setup>
import { downloadApp } from '@local-utils/common';
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';

.nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  width: 100%;
  max-width: $pc-max-width;
  height: 1.2rem;
  background: #ffffff;

  .main {
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 62.5%;
    max-width: $pc-main-max-width;
  }

  .pc-logo {
    display: flex;
    margin: 0.25rem auto auto 0.7rem;
    width: 2.3rem;
    height: auto;
  }

  .mobile-logo {
    display: none;
  }

  .download {
    display: flex;
    align-items: center;
    width: 2.3rem;
  }
}

@media (max-width: 768px) {
  .nav {
    display: none;
  }
}
</style>
